import Store from "@/store";

const globalConfigs = [
    {key: 'background', value: ''},
    {key: 'showEffects', value: true},
    {key: 'showQrCode', value: true},
    {key: 'showRemarks', value: true},
    {key: 'showStatistics', value: true},
    {key: 'cardType', value: true},
    {key: 'appVersion', value: ''},
    {key: 'isReadNoticeForUser', value: false},
    {key: 'useAI', value: true},
    {key: 'useRedis', value: true},
    {key: 'useThirdService', value: true},

];

export function f(_this = this, websiteConfiguration = null) {
    console.log("this", _this, websiteConfiguration);
    if (websiteConfiguration === null) {
        console.log("进入初始化Config");
        let obj = {};
        for (let i = 0; i < globalConfigs.length; i++) {
            obj[globalConfigs[i].key] = globalConfigs[i].value;
            _this.$store.commit('commitValue', {key: globalConfigs[i].key, value: globalConfigs[i].value})
        }
        localStorage.setItem('www.static.lijun.space', JSON.stringify(obj));
    } else {
        let parse = JSON.parse(websiteConfiguration);
        for (let i = 0; i < globalConfigs.length; i++) {
            if (parse.hasOwnProperty(globalConfigs[i].key)) {
                _this.$store.commit('commitValue', {key: globalConfigs[i].key, value: parse[globalConfigs[i].key]})
            } else {
                changeProperty(_this, 'www.static.lijun.space', globalConfigs[i].key, globalConfigs[i].value, true);
            }
        }
    }
}

export function getProperty(_this = this, itemKey, propertyKey, defaultValue, isFill = false) {
    let item = localStorage.getItem(itemKey);
    if (item !== undefined && item !== null) {
        let parse = JSON.parse(item);
        if (parse.hasOwnProperty(propertyKey)) {
            return parse[propertyKey];
        } else {
            if (isFill) changeProperty(_this, itemKey, propertyKey, defaultValue, isFill);
            return defaultValue;
        }
    } else {
        if (isFill) changeProperty(_this, itemKey, propertyKey, defaultValue, isFill);
        return defaultValue;
    }
}

export function changeProperty(_this = this, itemKey = 'www.static.lijun.space', propertyKey, value, isFill = true) {
    console.log('this', _this);
    let item = localStorage.getItem(itemKey);
    console.log('changeProperty', value);
    if (item !== undefined && item !== null) {
        let parse = JSON.parse(item);
        if (parse.hasOwnProperty(propertyKey) || isFill) {
            parse[propertyKey] = value
            console.log(parse);
            localStorage.setItem(itemKey, JSON.stringify(parse));
            console.log(localStorage.getItem(itemKey));
            _this.$store.commit('commitValue', {key: propertyKey, value: value})
        }
    } else {
        console.log("进入Else")
        if (isFill) {
            let obj = {[propertyKey]: value}
            localStorage.setItem(itemKey, JSON.stringify(obj));
            _this.$store.commit('commitValue', {key: propertyKey, value: value})
        }
    }
}
